import Glide from '@glidejs/glide';
import { initWhenVisible } from '../_shared/lazy-init';

( () => {
	const testimonialBlocks = document.querySelectorAll< HTMLDivElement >(
		'.wp-block-phrase-com-testimonials'
	);
	if ( ! testimonialBlocks.length ) {
		return;
	}

	testimonialBlocks.forEach( ( testimonialBlock ) => {
		// The progress bar does not exists if the block has only one testimonial.
		// In that case, we don't need to initialize Glide.
		const progressBars = testimonialBlock.querySelector< HTMLDivElement >(
			'.wp-block-phrase-com-testimonials__carousel-progress-bar'
		);

		if ( ! progressBars ) {
			return;
		}

		initWhenVisible( testimonialBlock, () => {
			const glide = new Glide( testimonialBlock, {
				type: 'carousel',
				gap: 0,
				perView: 1,
				keyboard: false,
				autoplay: 8000,
				hoverpause: false,
			} );

			// Function to scroll active logo into view
			const scrollActiveLogoIntoView = () => {
				const logoContainer = testimonialBlock.querySelector< HTMLDivElement >(
					'.wp-block-phrase-com-testimonials__company-logos'
				);
				const activeLogo = testimonialBlock.querySelector< HTMLButtonElement >(
					'.wp-block-phrase-com-testimonials__company-logo.glide__bullet--active'
				);

				if ( logoContainer && activeLogo ) {
					const containerRect = logoContainer.getBoundingClientRect();
					const logoRect = activeLogo.getBoundingClientRect();

					// Only scroll horizontally within the container, don't affect page scroll
					const scrollLeft =
						logoContainer.scrollLeft +
						( logoRect.left - containerRect.left ) -
						containerRect.width / 2 +
						logoRect.width / 2;

					logoContainer.scrollTo( {
						left: scrollLeft,
						behavior: 'smooth',
					} );
				}
			};

			glide.on( [ 'mount.after', 'run' ], () => {
				progressBars.classList.remove( 'is-running' );
				setTimeout( () => {
					progressBars.classList.add( 'is-running' );
				}, 1 );

				// Scroll active logo into view
				setTimeout( scrollActiveLogoIntoView, 100 );
			} );

			glide.mount();
		} );
	} );
} )();
